// The space key rolls the die when the roll is the player's. It presses the
// roll button, so the button is the one place that says when a roll may start.
// On a control that has the focus, the space key keeps its usual meaning.

import { ROLL_BUTTON_SELECTOR, ROLL_KEY } from '../constants';
import { currentCue } from './view';

const CONTROLS = 'button, a, input, select, textarea, summary, dialog';

/** Call once at startup. */
export const startRollKey = (): void => {
  window.addEventListener('keydown', (event) => {
    if (event.key !== ROLL_KEY || event.repeat) return;
    if (event.altKey || event.ctrlKey || event.metaKey) return;
    if (event.target instanceof Element && event.target.closest(CONTROLS)) return;
    const cue = currentCue();
    if (!cue.canRoll) return;
    const button = document.querySelector<HTMLButtonElement>(ROLL_BUTTON_SELECTOR);
    if (!button || button.disabled) return;
    // Without this, the space key also scrolls the page.
    event.preventDefault();
    button.click();
  });
};
